import * as React from 'react';
import { SeatMapRestrictions } from '@websky/graphql';
import { CdnIcon } from '@shared/ui';

export const filterIcons = {
	[SeatMapRestrictions.PregnantWomen]: <CdnIcon icon="Seat map/Female" />,
	[SeatMapRestrictions.PassengersUnder18]: <CdnIcon icon="Seat map/Male" />,
	[SeatMapRestrictions.Infant]: <CdnIcon icon="Tour/Child" />,
	[SeatMapRestrictions.WithAnimals]: <CdnIcon icon="Baggage/Pet in cabin" />,
	[SeatMapRestrictions.SeriouslyIllPeople]: <CdnIcon icon="Info/Accessible" />,
	[SeatMapRestrictions.DoNotSpeakTheLanguage]: <CdnIcon icon="Airport/DoNotSpeakTheLanguage" />,
	[SeatMapRestrictions.ElderlyPerson]: <CdnIcon icon="Airport/ElderlyPerson" />,
	[SeatMapRestrictions.EscortedChildren]: <CdnIcon icon="Airport/EscortedChildren" />,
	[SeatMapRestrictions.NeedOxygenEquipment]: <CdnIcon icon="Airport/NeedOxygenEquipment" />,
	[SeatMapRestrictions.PassengersOnStretchers]: <CdnIcon icon="Airport/PassengersOnStretchers" />,
	[SeatMapRestrictions.RequiringAccompany]: <CdnIcon icon="Airport/RequiringAccompany" />,
	[SeatMapRestrictions.Unaccompanied]: <CdnIcon icon="Airport/Unaccompanied" />,
	[SeatMapRestrictions.VisuallyOrHearingImpaired]: <CdnIcon icon="Airport/VisuallyOrHearingImpaired" />,
	titleIcon: (
		<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g id="Icon">
				<path
					id="vector"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12.5 3V8.41667H13.75V6.33333H17.5V5.08333H13.75V3L12.5 3ZM10.8333 6.33333H2.5V5.08333H10.8333V6.33333ZM12.5 13V18.4167H13.75V16.3333H17.5V15.0833H13.75V13H12.5ZM10.8333 16.3333H2.5V15.0833H10.8333V16.3333ZM7.5 8L7.5 13.4167H6.25L6.25 11.3333H2.5L2.5 10.0833H6.25L6.25 8L7.5 8ZM17.5 10.0833L9.16667 10.0833L9.16667 11.3333L17.5 11.3333V10.0833Z"
					fill="currentColor"
				/>
			</g>
		</svg>
	)
};
